/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from 'environments/environment';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'development-orders',
        title: 'Development Orders',
        // type: 'group',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/planning/development-orders/rnd',
        // children: [
        //     // {
        //     //     id: 'development-orders-production',
        //     //     title: 'DO - Production',
        //     //     type: 'basic',
        //     //     icon: 'heroicons_outline:chart-pie',
        //     //     link: '/planning/development-orders/production',
        //     // },
        //     {
        //         id: 'development-orders-rnd',
        //         title: 'DO - Development',
        //         type: 'basic',
        //         icon: 'heroicons_outline:chart-pie',
        //         link: '/planning/development-orders/rnd',
        //     },
        // ],
    },
    {
        id: 'registrations',
        title: 'Registrations',
        type: 'group',
        icon: 'heroicons_outline:arrow-trending-up',
        link: '/measurement/registry/production',
        children: [
            {
                id: 'registry-production',
                title: 'Registration Production',
                type: 'basic',
                icon: 'heroicons_outline:book-open',
                link: '/measurement/registry/production',
            },
            {
                id: 'registry-development',
                title: 'Registration Development',
                type: 'basic',
                icon: 'heroicons_outline:book-open',
                link: '/measurement/registry/rnd',
            },
        ],
    },
    {
        id: 'results',
        title: 'Results',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: 'measurement/results',
    },
    {
        id: 'reliability',
        title: 'Reliability',
        type: 'basic',
        icon: 'heroicons_outline:cog',
        link: 'reliability',
    },
    {
        id: 'calo',
        title: 'Calo Measurements',
        type: 'basic',
        icon: 'heroicons_outline:document-chart-bar',
        link: '/calorimeter-measurements',
    },
    {
        id: 'noise',
        title: 'Noise Measurements',
        type: 'basic',
        icon: 'heroicons_outline:musical-note',
        link: '/noise-measurements',
    },
    {
        id: 'eoc',
        title: 'EOC Measurements',
        type: 'basic',
        icon: 'heroicons_outline:document-chart-bar',
        link: '/eoc-measurements',
    },
    {
        id: 'planning',
        title: 'Planning',
        type: 'group',
        icon: 'heroicons_outline:arrow-trending-up',
        children: [
            {
                id: 'ats',
                title: 'ATS',
                type: 'basic',
                icon: 'heroicons_outline:book-open',
                link: '/planning/ats',
            },
            {
                id: 'sks',
                title: 'SKS',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: 'planning/sks',
            },
        ],
    },
    {
        id: 'divider-2',
        type: 'divider',
    },
    {
        id: 'admin',
        title: 'Administration',
        type: 'group',
        icon: 'heroicons_outline:cog-8-tooth',
        children: [
            {
                id: 'users',
                title: 'Users',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/admin/users',
                hidden: () => environment.production, // Hides the item if in production
            },
            {
                id: 'developmenorder',
                title: 'Development Order',
                type: 'group',
                icon: 'heroicons_outline:chevron-up-down',
                children: [
                    {
                        id: 'performance-test',
                        title: 'Performance Tests',
                        type: 'basic',
                        icon: 'heroicons_outline:funnel',
                        link: '/admin/performance-tests',
                    },
                    {
                        id: 'reliability-test',
                        title: 'Reliability Tests',
                        type: 'basic',
                        icon: 'heroicons_outline:funnel',
                        link: '/admin/reliability-tests',
                    },
                    {
                        id: 'approval-test',
                        title: 'Approval Tests',
                        type: 'basic',
                        icon: 'heroicons_outline:funnel',
                        link: '/admin/approval-tests',
                    },
                    {
                        id: 'development-order-priorities',
                        title: 'Development order priorities',
                        type: 'basic',
                        icon: 'heroicons_outline:square-3-stack-3d',
                        link: '/admin/development-order-priorities',
                    },
                    {
                        id: 'development-order-windings',
                        title: 'Development order windings',
                        type: 'basic',
                        icon: 'heroicons_outline:square-3-stack-3d',
                        link: '/admin/development-order-windings',
                    },
                    {
                        id: 'admin/development-order-kit-return-types',
                        title: 'Kit return types',
                        type: 'basic',
                        icon: 'heroicons_outline:square-3-stack-3d',
                        link: '/admin/development-order-kit-return-types',
                    },
                ],
            },
            {
                id: 'compressors',
                title: 'Compressors',
                type: 'group',
                icon: 'heroicons_outline:cog-8-tooth',
                children: [
                    {
                        id: 'compressor-codes',
                        title: 'Compressor codes',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-codes',
                    },
                    {
                        id: 'compressor-types',
                        title: 'Compressor types',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-types',
                    },
                    {
                        id: 'compressor-data',
                        title: 'Compressor data',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-data',
                    },
                    {
                        id: 'compressor-applications',
                        title: 'Compressor applications',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-applications',
                    },
                    {
                        id: 'compressor-cooling-systems',
                        title: 'Compressor cooling systems',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-cooling-systems',
                    },
                    {
                        id: 'compressor-motor-types',
                        title: 'Compressor motor types',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-motor-types',
                    },
                    {
                        id: 'compressor-protector-types',
                        title: 'Compressor protector types',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-protector-types',
                    },
                    {
                        id: 'compressor-rotor-types',
                        title: 'Compressor rotor types',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-rotor-types',
                    },
                    {
                        id: 'compressor-start-equipments',
                        title: 'Compressor start equipments',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-start-equipments',
                    },
                    {
                        id: 'compressor-stator-types',
                        title: 'Compressor stator types',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-stator-types',
                    },
                    {
                        id: 'compressor-capacitors',
                        title: 'Compressor capacitors',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-pie',
                        link: '/admin/compressor-capacitors',
                    },
                ],
            },
            {
                id: 'tribology-admin',
                title: 'Tribology',
                type: 'group',
                icon: 'heroicons_outline:cog',
                children: [
                    {
                        id: 'tribology-wears',
                        title: 'Tribologia Wears',
                        type: 'basic',
                        icon: 'heroicons_outline:cog',
                        link: '/admin/tribology-wears',
                    },
                    {
                        id: 'tribology-levels',
                        title: 'Tribologia Levels',
                        type: 'basic',
                        icon: 'heroicons_outline:cog',
                        link: '/admin/tribology-levels',
                    },
                    {
                        id: 'tribology-evaluations',
                        title: 'Tribologia Evaluations',
                        type: 'basic',
                        icon: 'heroicons_outline:cog',
                        link: '/admin/tribology-evaluations',
                    },
                    {
                        id: 'tribology-components',
                        title: 'Tribologia Components',
                        type: 'basic',
                        icon: 'heroicons_outline:cog',
                        link: '/admin/tribology-components',
                    },
                ],
            },
            {
                id: 'measurement-test-type',
                title: 'Measurement Test Type',
                type: 'basic',
                icon: 'heroicons_outline:circle-stack',
                link: '/admin/measurement-test-type',
            },
            {
                id: 'test-conditions',
                title: 'Test Conditions',
                type: 'basic',
                icon: 'heroicons_outline:pencil',
                link: '/admin/test-conditions',
            },
            {
                id: 'calorimeters',
                title: 'Calorimeters',
                type: 'basic',
                icon: 'heroicons_outline:table-cells',
                link: '/admin/calorimeters',
            },
            {
                id: 'refrigerant',
                title: 'Refrigerants',
                type: 'basic',
                icon: 'heroicons_outline:circle-stack',
                link: '/admin/refrigerants',
            },
            {
                id: 'factories',
                title: 'Factories',
                type: 'basic',
                icon: 'heroicons_outline:map-pin',
                link: '/admin/factories',
            },
            {
                id: 'noise-chambers',
                title: 'Noise chambers',
                type: 'basic',
                icon: 'heroicons_outline:inbox',
                link: '/admin/noise-chambers',
            },
            {
                id: 'cataloguevalues',
                title: 'Catalogue values',
                type: 'basic',
                icon: 'heroicons_outline:archive-box',
                link: '/admin/cataloguevalues',
            },
            {
                id: 'projects',
                title: 'Projects',
                type: 'basic',
                icon: 'heroicons_outline:queue-list',
                link: '/admin/projects',
            },
            {
                id: 'print-labels',
                title: 'Print Labels',
                type: 'basic',
                icon: 'heroicons_outline:tag',
                link: '/admin/print-labels',
            },
        ],
    },
];

export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
